import { Api } from "../../api"
import { TCardEvent } from "../../utils/@types/data/eventCard"
import * as S from "./styled"

import { Link, useNavigate } from "react-router-dom"
import { ArrowRight, Calendar } from "lucide-react"
import getStore from "../../store"

type Props = {
  data: TCardEvent
  k: number
}

const EventCard = ({ k, data }: Props) => {
  const navigate = useNavigate()
  const { controllers } = getStore()

  const setEvent = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault()

    try {
      const req = await Api.get.eventInfo({ eventId: data.id })

      if (req.ok) {
        if (!req.data.is_ecommerce) {
          alert("Evento indisponível para venda online no momento.")
          return
        }

        sessionStorage.setItem("event", JSON.stringify(req.data))
        controllers.event.setData(req.data)
        navigate("/", { state: { fromSelect: true } })
      } else {
        alert(
          "Houve um erro ao selecionar o evento. Tente novamente mais tarde"
        )
      }
    } catch (error) {
      alert("Houve um erro ao selecionar o evento. Tente novamente mais tarde")
    }
  }

  return (
    <S.Component $k={k}>
      <Link
        onClick={setEvent}
        to={"/"}
        aria-label={`Selecionar evento ${data.name}`}
      >
        <S.ImageContainer>
          <img src={data.banner ?? ""} alt={data.name ?? ""} loading="lazy" />
        </S.ImageContainer>
        <S.EventInfo>
          <S.EventName>{data.name}</S.EventName>
          <S.CardBottom>
            <S.EventDate>
              <Calendar aria-hidden="true" />
              {data.dateStr}
            </S.EventDate>
            <S.GoIcon aria-hidden="true">
              <ArrowRight />
            </S.GoIcon>
          </S.CardBottom>
        </S.EventInfo>
      </Link>
    </S.Component>
  )
}

export default EventCard
